import { useState, useEffect } from "react";
import ProductCardSearch from "../components/ProductCardSearch";
import ProductCardFilter from "../components/ProductCardFilter";
import ProductCardHeaders from "../components/ProductCardHeaders";
import useDisplaySearchData from "../Hooks/useDisplaySearchData";

function SearchResults() {
  const [apiFilter, setApiFilter] = useState([]);
  const [grid, setGrid] = useState(true);
  const [active, setActive] = useState(0);
  const showResultData = useDisplaySearchData(apiFilter);

  const handleSwitchStyl = (boolVal) => {
    setGrid(boolVal);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  // const handleApplyFilters = (fltrs) => {
  //   setApiFilter(fltrs);
  // };

  const items = showResultData?.data?.data?.items || [];
  const category = showResultData?.data?.data?.categories || [];
  const data = showResultData?.data?.data || [];
  const totalItems = showResultData?.data?.data.totalItems

  return (
    <div>
      <div className="flex justify-center  bg-[#f8f8f8] fixed w-[100%] ">
        <h3 className="font-bold text-2xl ">SEARCH RESULT</h3>
      </div>

      <div className="w-full mt-5 flex justify-center">
        <div className="w-[95%] h-full">
          <ProductCardHeaders
            headers={data}
            active={active}
            setActive={setActive}
          />
          <div className="h-[34px] flex">
            <div className="w-[70%] text-[12px] text-gray-400 flex items-center">
              <p>Showing {totalItems} results for man</p>
            </div>
            <div className="w-[30%]">
              <div className="flex justify-end ">
                <div className="w-[32px] h-[32px] cursor-pointer">
                  <i
                    className="fa-solid fa-table "
                    onClick={() => handleSwitchStyl(true)}
                  ></i>
                </div>
                <div className="w-[32px] h-[32px] cursor-pointer">
                  <i
                    className="fa-solid fa-bars "
                    onClick={() => handleSwitchStyl(false)}
                  ></i>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-2">
            <div className="grid grid-cols-10 gap-4">
              <div className="col-span-2">
                <ProductCardFilter data={data} apiFilter={apiFilter} setApiFilter={setApiFilter} />
              </div>

              <div className="col-span-8">
                <div
                  className={`grid gap-3 ${
                    grid === true ? "grid-cols-4" : "grid-cols-1"
                  }`}
                >
                  {active === 0
                    ? items?.map((itm, idx) => (
                        <ProductCardSearch
                          viewStyle={grid}
                          name={itm.title}
                          price={itm.price}
                          link={itm.link}
                          img={itm.image_link}
                          key={idx}
                          button="Product"
                        />
                      ))
                    : category?.map((itm, idx) => (
                        <ProductCardSearch
                          viewStyle={grid}
                          name={itm.title}
                          price={itm.price}
                          link={itm.link}
                          img={itm.image}
                          key={idx}
                          button="Category"
                        />
                      ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SearchResults;